// composables/useAnimatedCounter.ts
import { ref, watch, type Ref } from 'vue'

export function useAnimatedNumber(source: Ref<number>, duration = 1000) {
  const animatedValue = ref<number>(source.value)

  function animate(from: number, to: number) {
    if (from === to) return

    let start: number | null = null

    function step(timestamp: number) {
      if (!start) start = timestamp
      const elapsed = timestamp - start
      const progress = Math.min(elapsed / duration, 1)
      animatedValue.value = Math.floor(from + (to - from) * progress)

      if (progress < 1) {
        requestAnimationFrame(step)
      } else {
        animatedValue.value = to
      }
    }

    requestAnimationFrame(step)
  }

  watch(source, (newVal, oldVal) => {
    animate(oldVal, newVal)
  })

  return {
    animatedValue,
  }
}
